export const productCardDefectValueModalName = 'product-card-defect-value';
